import { render, staticRenderFns } from "./order.vue?vue&type=template&id=2c2669cc&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&lang=less&"
import style1 from "./order.vue?vue&type=style&index=1&id=2c2669cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2669cc",
  null
  
)

export default component.exports